'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Comment = function (_React$PureComponent) {
  _inherits(Comment, _React$PureComponent);

  function Comment() {
    _classCallCheck(this, Comment);

    return _possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).apply(this, arguments));
  }

  _createClass(Comment, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          size = _props.size;

      return _react2.default.createElement(
        'svg',
        {
          width: size,
          height: size,
          viewBox: '0 0 20 20',
          xmlns: 'http://www.w3.org/2000/svg'
        },
        _react2.default.createElement(
          'g',
          { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement(
            'g',
            { fill: color },
            _react2.default.createElement('path', { d: 'M2,8.96479437 C2,4.56398695 5.58407028,1 10,1 C14.4159297,1 18,4.56398695 18,8.96479437 C18,13.3656018 14.4159297,16.9385887 10,16.9385887 C9.04798133,16.9385887 6.00007843,19.2784037 5.15206181,18.9724048 C4.51204926,18.7385821 6.04807937,15.9305924 5.48806839,15.5525938 C3.38402714,14.1125991 2,11.7007844 2,8.96479437 Z M10.0108461,2.48069948 C6.45483327,2.48069948 3.357559,5.40307203 3.357559,9.01234315 C3.357559,12.6124532 6.45483327,15.2874776 10.0108461,15.2874776 C13.5667013,15.2874776 16.656088,12.6124532 16.656088,9.01234315 C16.656088,5.40307203 13.5667013,2.48069948 10.0108461,2.48069948 Z' }),
            _react2.default.createElement('path', { d: 'M9.72126633,10.9347553 C9.95285715,10.9347553 10.1471805,11.0412338 10.1418566,11.174332 L10.1418566,11.759964 C10.1418566,11.8930621 9.95285715,11.9995407 9.72126633,11.9995407 L6.54820586,11.9995407 C6.31661504,11.9995407 6.12761563,11.8930621 6.12761563,11.759964 L6.12761563,11.174332 C6.12761563,11.0412338 6.31661504,10.9347553 6.54820586,10.9347553 L9.72126633,10.9347553 Z M13.1605231,8.53118546 C13.392114,8.53118546 13.5811134,8.637664 13.5811134,8.77076217 L13.5811134,9.35639414 C13.5811134,9.48949231 13.392114,9.59597085 13.1605231,9.59597085 L6.54820586,9.59597085 C6.31661504,9.59597085 6.12761563,9.48949231 6.12761563,9.35639414 L6.12761563,8.77076217 C6.12761563,8.637664 6.31661504,8.53118546 6.54820586,8.53118546 L13.1605231,8.53118546 Z M13.1605231,6.12761563 C13.392114,6.12761563 13.5811134,6.23409417 13.5811134,6.36719235 L13.5811134,6.95282431 C13.5811134,7.08592248 13.392114,7.19240102 13.1605231,7.19240102 L6.54820586,7.19240102 C6.31661504,7.19240102 6.12761563,7.08592248 6.12761563,6.95282431 L6.12761563,6.36719235 C6.12761563,6.23409417 6.31661504,6.12761563 6.54820586,6.12761563 L13.1605231,6.12761563 Z' })
          )
        )
      );
    }
  }]);

  return Comment;
}(_react2.default.PureComponent);

Comment.defaultProps = {
  color: '#000000',
  size: 20
};

Comment.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

exports.default = Comment;